import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { useDispatch, useSelector } from "react-redux";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import { closeDialog } from "store/vino/trackingSlice";
import { dateShortString } from "utils/date-format";

const TrackPackageDialog = () => {
    const dispatch = useDispatch();
    const list = useSelector(({ vino }) => vino.tracking.list);
    const openTrackingDialog = useSelector(({ vino }) => vino.tracking.openTrackingDialog);

    const handleCloseTrackingDialog = () => {
        dispatch(closeDialog())
    }

    return (
        <Dialog
            open={openTrackingDialog}
            onClose={handleCloseTrackingDialog}
            fullWidth
            classes={{
                paper: "m-24",
            }}
            maxWidth="xs"
        >
            <AppBar position="static" elevation={0}>
                <Toolbar className="flex w-full">
                    <Typography variant="subtitle1" color="inherit">
                        Order tracking
                    </Typography>
                </Toolbar>
            </AppBar>
            <DialogContent>
                <Stepper className="pl-24" activeStep={0} orientation="vertical">
                    {list.map((track, index) => (
                        <Step key={index}>
                            <StepLabel>{`${track.derivedStatus}, ${dateShortString(track.date)}`}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </DialogContent>
            <DialogActions className="justify-between p-4 pb-16 px-24">
                <Button
                    id="btnClose"
                    color="info"
                    variant="contained"
                    onClick={handleCloseTrackingDialog}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog >
    );
};

export default TrackPackageDialog;
